import { Controller } from "@hotwired/stimulus"
import { turboFetch } from "../util/common"

export default class extends Controller {
  static values = {
    url: String,
    userId: Number
  }

  async submit(event) {
    event.preventDefault()
    event.stopPropagation()

    this.element.disabled = true

    try {
      await turboFetch(this.urlValue, {
        method: "POST",
        body: JSON.stringify({
          speaker_invitation: { user_id: this.userIdValue }
        })
      })
    } catch (error) {
      console.error("Re-invite request failed:", error)
      this.element.disabled = false
    }
  }
}
